import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useMembership } from '../../../contexts/MembershipServiceContext';
import CommonIcons from '../../icons/Common';

import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';

const Header = () => {
	const { membershipListData } = useMembership();
	const { result } = useSelector(
		(state) => state.customerDetailsSlice.postBrowserDetails
	);

	const location = useLocation();

	const isConfirmationPage = location.pathname.includes('/confirmation');

	return (
		<Stack
			component='header'
			direction='row'
			justifyContent='space-between'
			alignItems='center'
			pt={3}
			px={2}
		>
			<Link href={result.landing_page_link || '/'}>
				<Box
					component='img'
					src={membershipListData?.logo}
					alt={membershipListData?.name}
					sx={{
						height: { xs: 50, sm: 65, md: 75 },
						maxWidth: { xs: 200, sm: 250, md: 300 },
						objectFit: 'contain'
					}}
				/>
			</Link>
			{!isConfirmationPage && (
				<Badge
					badgeContent={1}
					color='success'
					sx={{
						'& .MuiBadge-badge': {
							fontSize: '0.65rem',
							height: 18,
							minWidth: 18,
							color: 'primary'
						}
					}}
				>
					<CommonIcons.cart sx={{ fontSize: 28, color: 'text.secondary' }} />
				</Badge>
			)}
		</Stack>
	);
};

export default Header;
